import cn from 'classnames/bind';
import * as React from 'react';
import '../../Icons/ArrowDown/index.js';
import '../../Icons/Camera/index.js';
import '../../Icons/Category/index.js';
import { CheckCircle } from '../../Icons/CheckCircle/index.js';
import '../../Icons/Close/index.js';
import '../../Icons/Favorite/index.js';
import '../../Icons/Lens/index.js';
import '../../Icons/LensHeart/index.js';
import '../../Icons/Phone/index.js';
import '../../Icons/Pin/index.js';
import '../../Icons/Promo/index.js';
import '../../Icons/Share/index.js';
import '../../Icons/Bell/index.js';
import '../../Icons/Bin/index.js';
import '../../Icons/Check/index.js';
import '../../Icons/TriangleExclamation/index.js';
import '../../Icons/ShoppingBag/index.js';
import { Palette } from '../../lib/constants.js';
import classes from './index.module.scss.js';

const cx = cn.bind(classes);
class ItemQualitySeal extends React.PureComponent {
    render() {
        const { text, className } = this.props;
        return (React.createElement("p", { className: cx(className, classes.container) },
            React.createElement(CheckCircle, { fillColor: Palette.NeutralGrey3 }),
            React.createElement("span", { className: `body-text small ${cx(classes.label)}` }, text)));
    }
}

export { ItemQualitySeal };
//# sourceMappingURL=index.js.map
